import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EN_LANG, FR_LANG } from 'components/langSwitcher/constants';
import { convertToStringOrNull } from 'utils/dataTypes.utils';
import styles from 'components/langSwitcher/langSwitcher.module.css';
import { useNavigate } from 'react-router-dom';
import { EMPTY_STRING } from 'constants/shared';

export const LangSwitcher = ({ isBlack }: { isBlack: boolean }) => {
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const languageOptions = [EN_LANG, FR_LANG];

    const [selectedLanguage, setSelectedLanguage] = useState(
        i18n.resolvedLanguage || languageOptions[0]
    );

    const handleOptionClick = (option: string) => {
        setSelectedLanguage(option);
        i18n.changeLanguage(option);

        const currentPath = location.pathname;
        let newPath: string;
        if (option === EN_LANG) {
            newPath = currentPath.startsWith('/en')
                ? currentPath
                : `/en${currentPath}`;
        } else {
            newPath = currentPath.replace(/^\/en/, EMPTY_STRING);
        }
        navigate(newPath);
    };

    const activeBtnStyles = (option: string) =>
        convertToStringOrNull(selectedLanguage === option, styles.active);

    return (
        <div className={styles.languageSwitcher}>
            <div
                className={`${styles.switcherBtn} ${isBlack ? styles.switcherBtn_black : null} ${activeBtnStyles(FR_LANG)}`}
                onClick={() => handleOptionClick(FR_LANG)}
            >
                <span>Fr</span>
            </div>

            <div
                className={`${styles.switcherBtn} ${isBlack ? styles.switcherBtn_black : null} ${activeBtnStyles(EN_LANG)}`}
                onClick={() => handleOptionClick(EN_LANG)}
            >
                <span>En</span>
            </div>
        </div>
    );
};
